import { createSelector } from 'reselect';

import { UserSettingsObjectType } from '~/actions/couples/types/userSettingsActionTypes';
import { RootState } from '~/reducers';
import { UserSettingView } from '~/types/responseTypes';

export const getUserSettingsState = (state: RootState): UserSettingsObjectType =>
  state.couples?.userSettings?.settings;

export const getUserSetting = (key: string) =>
  createSelector(getUserSettingsState, (settings) => {
    return settings
      ? settings[key]
      : {
          flag: false,
          createdAt: null,
          updatedAt: null,
        };
  });

export const getUserSettings = (keys: string[]) =>
  createSelector(getUserSettingsState, (settings) => {
    return keys.reduce((result, current) => {
      return {
        ...result,
        [current]: settings[current] || {
          flag: false,
          createdAt: null,
          updatedAt: null,
        },
      };
    }, {} as Record<string, UserSettingView>);
  });
